var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.address)?_c('div',_vm._l((_vm.formattedAddress),function(part){return _c('address',{key:part},[_vm._v(" "+_vm._s(part)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }